// --- Pop Snax: Make native FILTER/SORT sticky on mobile (show on scroll-up) ---
(function () {
  const MOBILE_MAX = 768;
  if (window.innerWidth > MOBILE_MAX) return; // mobile only

  // Native container from your theme
  const facets = document.getElementById('facets-filterable');
  if (!facets) return;

  // Find the row that contains the native FILTER and SORT buttons
  // We look for a row with two <button role="button"> children labeled Filter/Sort.
  let toolbar = null;
  const rows = facets.querySelectorAll('.flex, .facets__controls, .collection-filters');
  rows.forEach(row => {
    if (toolbar) return;
    const btns = row.querySelectorAll('button[role="button"]');
    if (btns.length >= 2) {
      const t1 = (btns[0].textContent || '').trim().toLowerCase();
      const t2 = (btns[1].textContent || '').trim().toLowerCase();
      if (t1.includes('filter') && t2.includes('sort')) toolbar = row;
    }
  });
  if (!toolbar) return;

  // Measure header/announcement height so we don't overlap
  const header = document.querySelector('header') || document.querySelector('[data-header]');
  const announce = document.querySelector('[data-announcement-bar]') || document.querySelector('.announcement-bar');
  const topOffset = (header?.offsetHeight || 0) + (announce?.offsetHeight || 0);

  // Expose dynamic values to CSS
  toolbar.style.setProperty('--psx-top', `${topOffset + 8}px`); // small breathing room
  const tbHeight = toolbar.offsetHeight || 52;
  toolbar.style.setProperty('--psx-toolbar-h', `${tbHeight}px`);

  // Placeholder prevents layout jump when toolbar becomes fixed
  const placeholder = document.createElement('div');
  placeholder.className = 'psx-native-placeholder';
  placeholder.style.setProperty('--psx-toolbar-h', `${tbHeight}px`);

  let lastY = window.scrollY;
  let sticky = false;

  function update() {
    const y = window.scrollY;
    const scrollingUp = y < lastY;
    const pastHeader = y > (topOffset + 120); // start behavior a bit below header
    lastY = y;

    if (scrollingUp && pastHeader) {
      // Activate sticky mode once
      if (!sticky) {
        toolbar.classList.add('psx-native-sticky');
        if (!placeholder.parentNode) toolbar.before(placeholder);
        sticky = true;
      }
      // slide in
      toolbar.classList.add('psx-show');
    } else {
      // slide out
      toolbar.classList.remove('psx-show');

      // near the top, fully reset
      if (sticky && y < (topOffset + 40)) {
        toolbar.classList.remove('psx-native-sticky');
        if (placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
        sticky = false;
      }
    }
  }

  // Light throttling on scroll
  let t;
  window.addEventListener('scroll', () => {
    clearTimeout(t);
    t = setTimeout(update, 50);
  }, { passive: true });

  // Recompute if viewport changes
  window.addEventListener('resize', () => {
    if (window.innerWidth > MOBILE_MAX) return;
    const newTop = (header?.offsetHeight || 0) + (announce?.offsetHeight || 0) + 8;
    toolbar.style.setProperty('--psx-top', `${newTop}px`);
    const h = toolbar.offsetHeight || tbHeight;
    toolbar.style.setProperty('--psx-toolbar-h', `${h}px`);
    placeholder.style.setProperty('--psx-toolbar-h', `${h}px`);
  });
})();
// --- Pop Snax: XCloud desktop sticky filter (show on scroll-up) ---
(function () {
  const DESKTOP_MIN = 769; // wider coverage than 1025
  function isDesktop() { return window.innerWidth >= DESKTOP_MIN; }

  // Helper: wait for an element to appear (XCloud can mount late)
  function waitForEl(sel, timeout = 4000) {
    return new Promise((resolve) => {
      const el = document.querySelector(sel);
      if (el) return resolve(el);
      const obs = new MutationObserver(() => {
        const found = document.querySelector(sel);
        if (found) { obs.disconnect(); resolve(found); }
      });
      obs.observe(document.documentElement, { childList: true, subtree: true });
      setTimeout(() => { obs.disconnect(); resolve(null); }, timeout);
    });
  }

  async function init() {
    if (!isDesktop()) return;

    const root =
      document.getElementById('cloud_search_filters_root') ||
      document.querySelector('#cloud_search_filters_root, .xcloud-filters, .x-filter-bar, [id*="cloud_search_filters"]');

    const el = root || (await waitForEl('#cloud_search_filters_root'));
    if (!el) return;

    // Calculate top offset (header + announcement bars)
    const header = document.querySelector('header') || document.querySelector('[data-header]');
    const announce = document.querySelector('[data-announcement-bar]') || document.querySelector('.announcement-bar');
    const topOffset = ((header?.offsetHeight || 0) + (announce?.offsetHeight || 0));
    el.style.setProperty('--psx-sticky-top', `${topOffset}px`);

    // Measure height for placeholder
    const barH = el.offsetHeight || 60;
    el.style.setProperty('--psx-sticky-h', `${barH}px`);
    const placeholder = document.createElement('div');
    placeholder.className = 'psx-sticky-placeholder';
    placeholder.style.setProperty('--psx-sticky-h', `${barH}px`);

    let lastY = window.scrollY;
    let activated = false;

    function onScroll() {
      if (!isDesktop()) return;
      const y = window.scrollY;
      const scrollingUp = y < lastY;
      const pastHeader = y > (topOffset + 200); // tweak 120–300 if you want
      lastY = y;

      if (scrollingUp && pastHeader) {
        if (!activated) {
          el.classList.add('psx-stick');
          if (!placeholder.parentNode) el.after(placeholder);
          activated = true;
        }
        el.classList.add('psx-show');
      } else {
        el.classList.remove('psx-show');
        // Fully reset near the top
        if (activated && y < (topOffset + 50)) {
          el.classList.remove('psx-stick');
          if (placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
          activated = false;
        }
      }
    }

    // Throttled scroll
    let t;
    window.addEventListener('scroll', () => {
      clearTimeout(t);
      t = setTimeout(onScroll, 50);
    }, { passive: true });

    // Recompute offsets on resize (header height can change)
    window.addEventListener('resize', () => {
      if (!isDesktop()) return;
      const newTop = ((header?.offsetHeight || 0) + (announce?.offsetHeight || 0));
      el.style.setProperty('--psx-sticky-top', `${newTop}px`);
      const newH = el.offsetHeight || barH;
      el.style.setProperty('--psx-sticky-h', `${newH}px`);
      placeholder.style.setProperty('--psx-sticky-h', `${newH}px`);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
